import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"icon-download\"><path d=\"M16,11h5L12,21,3,11H8V0h8Zm1,11H7v2H17Z\" transform=\"translate(-3)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol